import generalTransformer from '@/services/general/filters/serverTableDataTransformer';

export default function transform(serverTableData) {
  if (serverTableData) {
    if (serverTableData.orderBy === 'cliNom') {
      serverTableData.orderBy = 'Tiers.NomCommercial';
    }
    if (serverTableData.query && serverTableData.query.archive === 'null') {
      serverTableData.query.archive = null;
    }
  }
  return generalTransformer(serverTableData);
}
